const LANGUAGE_MAP = {
    'TEMPLATES': {
        'en': 'Templates',
        'es': 'Plantillas',
    },
    'GRAPHIC_ORGANIZERS': {
        'en': 'Graphic Organizers',
        'es': 'Organizadores gráficos',
    },
    'LESSON_PLANS': {
        'en': 'Lesson Plans',
        'es': 'Planes de lecciones',
    },
    'VOCABULARY_JOURNAL': {
        'en': 'My Academic Vocabulary Journal',
        'es': 'Mi Cuaderno de <br>Vocabulario Académico',
    },
    'MATH_JOURNAL': {
        'en': 'Academic Writing Journal <br>for Math',
        'es': 'Cuaderno de Escritura Académica para <br>Matemáticas',
    },
    'SENTENCE_STEMS': {
        'en': 'Sentence Stems',
        'es': 'Fragmentos de oraciones u Oraciones anclas',
    },
    'FILL_IN_THE_BLANK_FRAMES': {
        'en': 'Fill-in-the-Blank Frames',
        'es': 'Fragmentos de oraciones con espacios para llenar',
    },
    '3_LEVELS': {
        'en': '3 Levels',
        'es': '3 niveles',
    },
    '4_LEVELS': {
        'en': '4 Levels',
        'es': '4 niveles',
    },
    '6_LEVELS': {
        'en': '6 Levels',
        'es': '6 niveles',
    },
    'CA_ELD': {
        'en': 'CA ELD Standards',
        'es': 'Estándares de Desarrollo del Lenguaje en Inglés de California',
    },
    'TX_ELD': {
        'en': 'TX ELD Standards',
        'es': 'Estándares de Desarrollo del Lenguaje en Inglés de Texas',
    },
    'WIDA_ELD': {
        'en': 'WIDA ELD Standards',
        'es': 'Estándares de Desarrollo del Lenguaje en Inglés de WIDA',
    },
    'LEARN_MORE': {
        'en': 'Learn more about',
        'es': 'Obtenga más información sobre',
    },
    'CREATE_GRAPHIC_ORGANIZER': {
        'en': 'Create your OWN graphic organizer',
        'es': 'Crea tu PROPIO organizador gráfico',
    },
    'CREATE_GO_DESCRIPTION': {
        'en': 'Let Drawp build a graphic organizer slide with placeholders from your worksheet images.',
        'es': 'Deje que Drawp cree una diapositiva de organizador gráfico con marcadores de posición de las imágenes de su hoja de trabajo.',
    },
    'UPLOAD': {
        'en': 'Upload',
        'es': 'Subir',
    },
    'ENGLISH': {
        'en': 'English',
        'es': 'Inglés',
    },
    'SPANISH': {
        'en': 'Spanish',
        'es': 'Español',
    },
    'FILTER_OPTIONS': {
        'en': 'Filter Options',
        'es': 'Filtros',
    },
    'THEME': {
        'en': 'Theme',
        'es': 'Tema',
    },
    'FREE': {
        'en': 'Free',
        'es': 'Gratis',
    },
    'COMPREHENSION': {
        'en': 'Comprehension',
        'es': 'Comprensión',
    },
    'FLOW': {
        'en': 'Flow',
        'es': 'Diagrama de progreso',
    },
    'MAPS': {
        'en': 'Maps',
        'es': 'Mapas',
    },
    'STORY': {
        'en': 'Story',
        'es': 'Historia',
    },
    'TABLES': {
        'en': 'Tables',
        'es': 'Tablas',
    },
    'TIME': {
        'en': 'Time',
        'es': 'Tiempo',
    },
    'WHEELS': {
        'en': 'Wheels',
        'es': 'Ruedas',
    },
    'CLOSE': {
        'en': 'Close',
        'es': 'Cerca',
    },
    'APPLY': {
        'en': 'Apply',
        'es': 'Aplicar',
    },
    'SEARCH_KEYWORD': {
        'en': 'Search by keyword',
        'es': 'Buscar por palabra clave',
    },
    'SELECT_CLEAR_FILTERS': {
        'en': 'Select/clear filters',
        'es': 'Seleccionar/borrar filtros',
    },
    'GRADE_LEVEL': {
        'en': 'Grade level',
        'es': 'Nivel de grado',
    },
    'SLIDES_NUMBER': {
        'en': 'Number of slides',
        'es': 'Número de diapositivas',
    },
    'VIEW_DETAILS': {
        'en': 'View details',
        'es': 'Véa los detalles',
    },
    'ADD_TO_SLIDE': {
        'en': 'Add to slide',
        'es': 'Agregar', /* Agregar a la diapositiva */
    },
    'ANSWER_KEY': {
        'en': 'Answer key slides',
        'es': 'Nivel de grado',
    },
    'SLIDES_SKIPPED': {
        'en': 'Slides will be skipped.',
        'es': 'Se saltarán las diapositivas.',
    },
    'SLIDES_INCLUDED': {
        'en': 'Slides will be included',
        'es': 'Se incluirán diapositivas',
    },
    'SUBJECT': {
        'en': 'Subject',
        'es': 'Sujeto',
    },
    'FILTER_BY_SUBJECT': {
        'en': 'Filter by subject',
        'es': 'Filtrar por tema',
    },
    'SELECT_SUBJECT': {
        'en': 'Please select a subject',
        'es': 'Seleccione un tema',
    },
    'MATH': {
        'en': 'Math',
        'es': 'Matemáticas',
    },
    'ELA': {
        'en': 'English Language Arts/Literacy',
        'es': 'Artes del lenguaje inglés/Lectoescritura',
    },
    'GRADE': {
        'en': 'Grade',
        'es': 'Calificación',
    },
    'FILTER_BY_GRADE': {
        'en': 'Filter by grade level',
        'es': 'Filtrar por nivel de grado',
    },
    'SELECT_GRADE': {
        'en': 'Please select grade level',
        'es': 'Seleccione el nivel de grado',
    },
    'AREA': {
        'en': 'Area',
        'es': 'Área',
    },
    'FILTER_BY_AREA': {
        'en': 'Filter by area',
        'es': 'Filtrar por área',
    },
    'DOMAIN': {
        'en': 'Domain',
        'es': 'Dominio',
    },
    'FILTER_BY_DOMAIN': {
        'en': 'Filter by domain',
        'es': 'Filtrar por dominio',
    },
    'MATH_SENTENCE_STEMS': {
        'en': 'Math Sentence Stems',
        'es': 'Fragmentos de oraciones de matemáticas',
    },
    'LEVEL': {
        'en': 'Level',
        'es': 'Nivel',
    },
    'LEVEL_1': {
        'en': 'Level 1',
        'es': 'Nivel 1',
    },
    'LEVEL_2': {
        'en': 'Level 2',
        'es': 'Nivel 2',
    },
    'LEVEL_3': {
        'en': 'Level 3',
        'es': 'Nivel 3',
    },
    'LEVEL_4': {
        'en': 'Level 4',
        'es': 'Nivel 4',
    },
    'LEVEL_1_DESCRIPTION': {
        'en': 'Understand the problem to persevere in solving.',
        'es': 'Entender el problema para perseverar en resolverlo.',
    },
    'LEVEL_2_DESCRIPTION': {
        'en': 'Reasoning, Finding Patterns, Tending to precision, and Recognizing tools to use.',
        'es': 'Razonamiento, Encontrar Patrones, Prestar atención a la precisión, y Reconocer herramientas que se pueden emplear.',
    },
    'SLIDE_ADDED': {
        'en': 'Slide has been added to the presentation.',
        'es': 'Se ha añadido una diapositiva a la presentación.',
    },
    'SEARCH': {
        'en': 'Search',
        'es': 'Busqueda',
    },
    'AREA_OF_FOCUS': {
        'en': 'Area of Focus',
        'es': 'Área de enfoque',
    },
    'ALL': {
        'en': 'All',
        'es': 'Todo',
    },
    'STORIES': {
        'en': 'Stories',
        'es': 'Cuentos',
    },

    'INFORMATIONAL_TEXT': {
        'en': 'Informational Text',
        'es': 'Texto informativo',
    },
    'LANGUAGE_PROFICIENCY': {
        'en': 'Language Proficiency',
        'es': 'Dominio del idioma',
    },
    'EMERGING': {
        'en': 'Emerging',
        'es': 'Emergentes',
    },
    'EXPANDING': {
        'en': 'Expanding',
        'es': 'En expansión',
    },
    'POETRY': {
        'en': 'Poetry',
        'es': 'Poesía',
    },
    'BRIDGING': {
        'en': 'Bridging',
        'es': 'Puente',
    },
    'BLOOM_WEBB': {
        'en': 'Bloom’s level / Webb’s DOK',
        'es': 'Nivel de Bloom / Profundidad de conocimiento de Webb',
    },
    'REMEMBERING_LEVEL_1': {
        'en': 'Remembering - DOK: Level 1',
        'es': 'Memoria - Profundidad de conocimiento de: Nivel 1',
    },
    'UNDERSTANDING_LEVEL_2': {
        'en': 'Understanding - DOK: Level 2',
        'es': 'Entendimiento - Profundidad de conocimiento de: Nivel 2',
    },
    'APPLYING_LEVEL_2': {
        'en': 'Applying - DOK: Level 2',
        'es': 'Aplicación - Profundidad de conocimiento de: Nivel 2',
    },
    'ANALYZING_LEVEL_3': {
        'en': 'Analyzing - DOK: Level 3',
        'es': 'Analizar - Profundidad de conocimiento de: Nivel 3',
    },
    'EVALUATING_LEVEL_3': {
        'en': 'Evaluating - DOK: Level 3',
        'es': 'Evaluar - Profundidad de conocimiento de: Nivel 3',
    },
    'CREATING_LEVEL_4': {
        'en': 'Creating - DOK: Level 4',
        'es': 'Crear - Profundidad de conocimiento de: Nivel 4',
    },
    'LANGUAGE': {
        'en': 'Language',
        'es': 'Idioma',
    },
    'QUESTIONS': {
        'en': 'QUESTIONS',
        'es': 'PREGUNTAS',
    },
    'SENTENCES': {
        'en': 'SENTENCES',
        'es': 'ORACIONES',
    },
    'STRATEGIES_PRODUCTS': {
        'en': 'Strategies and Products/Deliverables',
        'es': 'Estrategias y Productos',
    },
    'SELECT_PAIRS': {
        'en': 'Select Pairs',
        'es': 'Seleccionar pares',
    },
    'FRAMES_LINKED': {
        'en': 'Question/Sentence pairs will be linked',
        'es': 'Los pares de preguntas/oraciones se enlazarán',
    },
    'LANGUAGE_FUNCTIONS_STRATEGIES': {
        'en': 'Language Functions & Language Strategies',
        'es': 'Funciones del lenguaje y estrategias del lenguaje',
    },
    'TRIAL_PREVIEW_MESSAGE': {
        'en': 'This is a trial preview. For full access you\'ll need a premium subscription.',
        'es': 'Esta es una vista previa de prueba. Para tener acceso completo, necesitará una suscripción superior.',
    },
    'PURCHASE': {
        'en': 'PURCHASE',
        'es': 'COMPRA',
    },
    'PREMIUM': {
        'en': 'Premium',
        'es': 'Premium',
    },
    'CANVAS_AVAILABLE_FOR_PREMIUM': {
        'en': 'This canvas is available with a premium subscription',
        'es': 'This canvas is available with a premium subscription',
    },
    'CANCEL': {
        'en': 'Cancel',
        'es': 'Cancel',
    },
    'OK': {
        'en': 'Ok',
        'es': 'OK',
    },
    'UPGRADE': {
        'en': 'Upgrade',
        'es': 'Upgrade',
    },
    'CREATE_NEW': {
        'en': 'CREATE NEW',
        'es': 'CREAR NUEVO',
    },
    'PLAY_FROM_SLIDE': {
        'en': 'PLAY FROM SLIDE',
        'es': 'PRESIONE PARA ESCUCHAR',
    },
    'UPLOAD_FILE': {
        'en': 'Upload File',
        'es': 'Subir archivo',
    },
    'SELECT_AUDIO_FILE': {
        'en': 'Select existing audio file',
        'es': 'Seleccionar archivo de audio existente',
    },
    'LOADING_AUDIO': {
        'en': 'Loading audio',
        'es': 'Cargando audio',
    },
    'START_RECORDING': {
        'en': 'Start Recording',
        'es': 'Grabar',
    },
    'STOP_RECORDING': {
        'en': 'Stop Recording',
        'es': 'Parar',
    },
    'RESTART': {
        'en': 'Restart',
        'es': 'Reanudar',
    },
    'PROCESSING_AUDIO': {
        'en': 'Processing audio sticker...',
        'es': 'Procesando...',
    },
    'DFS_NO_MICROPHONE': {
        'en': 'Drawp for School does not have permission to access the microphone',
        'es': 'Drawp for School no tiene permiso para acceder al micrófono',
    },
    'SAFARI_MICROPHONE_INSTRUCTION': {
        'en': 'Enable microphone access by following the instructions available at the <a target="_blank" href="https://support.apple.com/guide/safari/websites-ibrwe2159f50/mac">following link </a> to record audio on your device.',
        'es': 'Habilite el acceso al micrófono, siguiendo las instrucciones disponibles en el <a target="_blank" href="https://support.apple.com/guide/safari/websites-ibrwe2159f50/mac">siguiente enlace</a> , para grabar audio en su dispositivo.',
    },
    'CHROME_MICROPHONE_INSTRUCTION': {
        'en': 'Enable microphone access by following the instructions available at the <a target="_blank" href="https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop">following link </a> to record audio on your device.',
        'es': 'Habilite el acceso al micrófono, siguiendo las instrucciones disponibles en el <a target="_blank" href="https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop">siguiente enlace</a> , para grabar audio en su dispositivo.',
    },
    'EDGE_MICROPHONE_INSTRUCTION': {
        'en': 'Enable microphone access by following the instructions available at the <a target="_blank" href="https://support.microsoft.com/en-us/windows/windows-10-camera-microphone-and-privacy-a83257bc-e990-d54a-d212-b5e41beba857">following link </a> to record audio on your device.',
        'es': 'Habilite el acceso al micrófono, siguiendo las instrucciones disponibles en el <a target="_blank" href="https://support.microsoft.com/en-us/windows/windows-10-camera-microphone-and-privacy-a83257bc-e990-d54a-d212-b5e41beba857">siguiente enlace</a> , para grabar audio en su dispositivo.',
    },
    'FIREFOX_MICROPHONE_INSTRUCTION': {
        'en': 'Enable microphone access by following the instructions available at the <a target="_blank" href="https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions">following link </a> to record audio on your device.',
        'es': 'Habilite el acceso al micrófono, siguiendo las instrucciones disponibles en el <a target="_blank" href="https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions">siguiente enlace</a> , para grabar audio en su dispositivo.',
    },
    'DEFAULT_MICROPHONE_INSTRUCTION': {
        'en': 'Enable microphone access to record audio on your device.',
        'es': 'Habilite el acceso al micrófono para grabar audio en su dispositivo.',
    },
    'PLAY_FROM_DEFAULT_GOOGLE': {
        'en': 'Play from slide tool is only available for your default Google account. Follow the steps at <a href="https://drawpforschool.com/google-slides-add-on/#multi-login-issue-fix" target="_blank">this link</a> to ensure that your active account is set as default.',
        'es': 'La herramienta “Presione para escuchar” solo está disponible para su cuenta de Google predeterminada. Siga los pasos en este enlace, para asegurarse de que su cuenta activa esté configurada como predeterminada.',
    },
    'VOICE_STICKER_ADDED': {
        'en': 'Voice sticker is added to your active slide',
        'es': 'La etiqueta de voz se agrega a su diapositiva activa',
    },
    'INCLUDE_VOICE_STICKER': {
        'en': 'Include voice sticker',
        'es': 'Incluir etiqueta de voz'
    },
    'INCLUDE_VOICE_STICKER_SUB': {
        'en': 'with the selected frame',
        'es': 'con fragmento de oración seleccionado'
    },
    'DFS_NO_CAMERA': {
        'en': 'Drawp for School does not have permission to access the camera',
        'es': 'Drawp for School no tiene permiso para acceder al camera',
    },
    'SAFARI_CAMERA_INSTRUCTION': {
        'en': 'Enable camera access by following the instructions available at the <a target="_blank" href="https://support.apple.com/guide/safari/websites-ibrwe2159f50/mac">following link </a> to record audio on your device.',
        'es': 'Habilite el acceso al camera, siguiendo las instrucciones disponibles en el <a target="_blank" href="https://support.apple.com/guide/safari/websites-ibrwe2159f50/mac">siguiente enlace</a> , para grabar audio en su dispositivo.',
    },
    'CHROME_CAMERA_INSTRUCTION': {
        'en': 'Enable camera access by following the instructions available at the <a target="_blank" href="https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop">following link </a> to record audio on your device.',
        'es': 'Habilite el acceso al camera, siguiendo las instrucciones disponibles en el <a target="_blank" href="https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop">siguiente enlace</a> , para grabar audio en su dispositivo.',
    },
    'EDGE_CAMERA_INSTRUCTION': {
        'en': 'Enable camera access by following the instructions available at the <a target="_blank" href="https://support.microsoft.com/en-us/windows/windows-10-camera-microphone-and-privacy-a83257bc-e990-d54a-d212-b5e41beba857">following link </a> to record audio on your device.',
        'es': 'Habilite el acceso al camera, siguiendo las instrucciones disponibles en el <a target="_blank" href="https://support.microsoft.com/en-us/windows/windows-10-camera-microphone-and-privacy-a83257bc-e990-d54a-d212-b5e41beba857">siguiente enlace</a> , para grabar audio en su dispositivo.',
    },
    'FIREFOX_CAMERA_INSTRUCTION': {
        'en': 'Enable camera access by following the instructions available at the <a target="_blank" href="https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions">following link </a> to record audio on your device.',
        'es': 'Habilite el acceso al camera, siguiendo las instrucciones disponibles en el <a target="_blank" href="https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions">siguiente enlace</a> , para grabar audio en su dispositivo.',
    },
    'DEFAULT_CAMERA_INSTRUCTION': {
        'en': 'Enable camera access to record audio on your device.',
        'es': 'Habilite el acceso al camera para grabar audio en su dispositivo.',
    },
    'NEW': {
        'en': 'Create New',
        'es': 'Crear Nuevo',
    },
    'PLAY_VOICE_MESSAGE': {
        'en': 'Select a Drawp Voice Sticker from your presentation and press the "Load selected audio" button to play it here.',
        'es': 'Seleccione una etiqueta de voz de Drawp de su presentación y presione el botón "Cargar audio seleccionado" para escucharlo.',
    },
    'LOAD_AUDIO': {
        'en': 'Load selected audio',
        'es': 'Cargar audio seleccionado',
    },
    'SIZE': {
        'en': 'Size',
        'es': 'Tamaño',
    },
    'ANY_SIZE': {
        'en': 'Any size',
        'es': 'Cualquier tamaño',
    },
    'SMALL': {
        'en': 'Small',
        'es': 'Pequeño',
    },
    'MEDIUM': {
        'en': 'Medium',
        'es': 'Mediano',
    },
    'LARGE': {
        'en': 'Large',
        'es': 'Grande',
    },
    'LOADING': {
        'en': 'Loading…',
        'es': 'Cargando…',
    },
    'SEARCH_IMAGES_LICENSE_MESSAGE': {
        'en': '<span>All content is sourced from Openverse and is under a <a href="https://creativecommons.org/licenses/" target="_blank">Creative Commons license</a> or is in the public domain.</span>',
        'es': '<span>Todo el contenido proviene de Openverse y está bajo una <a href="https://creativecommons.org/licenses/" target="_blank"> Licencia Creative Commons</a> o es de dominio público.',
    },
    'AI_CREATE': {
        'en': 'AI CREATE',
        'es': 'CREADO POR IA',
    },
    'AI_CREATE_DESCRIPTION': {
        'en': 'Create images from a text description using AI',
        'es': 'Crea imágenes a partir de una descripción de texto usando IA',
    },
    'EXAMPLES_AI_CREATE': {
        'en': 'Here are some examples to try the tool',
        'es': 'Aquí hay algunos ejemplos para probar la herramienta',
    },
    'DRAW': {
        'en': 'DRAW',
        'es': 'DIBUJAR',
    },
    'SKETCH': {
        'en': 'Sketch',
        'es': 'Dibujo',
    },
    'BRUSH': {
        'en': 'Brush',
        'es': 'Brocha',
    },
    'ERASER': {
        'en': 'Eraser',
        'es': 'Borrador',
    },
    'SELECT': {
        'en': 'Select',
        'es': 'Seleccionar',
    },
    'INSERT_IMAGE': {
        'en': 'Insert image',
        'es': 'Insertar imagen',
    },
    'EXPAND': {
        'en': 'Expand',
        'es': 'Expandir',
    },
    'SELECT_VIDEO_FILE': {
        'en': 'Select existing video file',
        'es': 'Seleccione un video pre-existente en los archivos',
    },
    'SOURCE_LANGUAGE': {
        'en': 'Source Language',
        'es': 'lenguaje fuente',
    },
    'TARGET_LANGUAGE': {
        'en': 'Target Language',
        'es': 'Target Language',
    },
    'DETECT_LANGUAGE': {
        'en': 'Detect Language',
        'es': 'Detect Language',
    },
    'LOAD_FROM_DEFAULT_GOOGLE': {
        'en': 'Load from slide tool is only available for your default Google account. Follow the steps at <a href="https://drawpforschool.com/google-slides-add-on/#multi-login-issue-fix" target="_blank">this link</a> to ensure that your active account is set as default.',
        'es': 'Load from slide tool is only available for your default Google account. Follow the steps at <a href="https://drawpforschool.com/google-slides-add-on/#multi-login-issue-fix" target="_blank">this link</a> to ensure that your active account is set as default.',
    },
    'SLIDE_ADDED_TO_PRESENTATION': {
        'en': 'Slides added to your presentation',
        'es': 'Diapositivas agregadas a su presentación',
    },
    'SELECT_SLIDE_SIZE': {
        'en': 'Select a size that matches your slide for the best display.',
        'es': 'Seleccione un tamaño que coincida con su diapositiva para obtener la mejor visualización.',
    },
    'SLIDE_TRANSLATION': {
        'en': 'Translate',
        'es': 'Traducción de diapositivas',
    },
    'SELECT_SLIDE': {
        'en': 'Select Slide',
        'es': 'Seleccionar diapositiva',
    },
    'TARGET_LANGUAGE': {
        'en': 'Target Language',
        'es': 'Idioma de destino',
    },
    'DUPLICATE_AND_TRANSLATE': {
        'en': 'Duplicate & Translate',
        'es': 'Duplicar y traducir',
    },
    'SELECT_TARGET_LANGUAGE': {
        'en': 'Select target language',
        'es': 'Seleccionar idioma de destino',
    },
};

const locale = navigator.language || navigator.userLanguage;

function getLocale() {
    return locale;
};

function localizedText(key) {

    if (['en', 'es'].includes(locale)) {
        return LANGUAGE_MAP[key][locale];
    }
    return LANGUAGE_MAP[key].en;
};

export {
    localizedText,
    getLocale
}